import React from "react";
import "../../index.css";
import axios from 'axios';
import slide1 from '../../assests/slider1.png';
import slide2 from '../../assests/slider2.png';
import slide3 from '../../assests/slider3.png';
import slide4 from '../../assests/slider4.png';
import event1 from '../../assests/peopleeventhome.png';
import event2 from '../../assests/event3.png';
import event3 from '../../assests/FDD.jpeg';
import camp1 from '../../assests/tezpurnov2023.jpeg';
import camp2 from '../../assests/biharcamp.png';
import camp3 from '../../assests/kenyajune2023.jpg';
import camp4 from '../../assests/lwrkenya2024.png';
import camppopup1 from '../../assests/camppopup1.jpeg';
import camppopup2 from '../../assests/camppopup2.jpeg';
import camppopup3 from '../../assests/camppopup3.jpeg';
import camppopup4 from '../../assests/camppopup4.jpeg';
import wwd1 from '../../assests/whatwedo1.png';
import wwd2 from '../../assests/whatwedo2.png';
import wwd3 from '../../assests/whatwedo3.png';
import wwd4 from '../../assests/whatwedo4.png';
import susan from '../../assests/Rectangle 516.png';
import news from '../../assests/Group 1867.png';
import logo from '../../assests/lwror.jpeg';
import line from '../../assests/Group 1870 line2.png';
import share from '../../assests/Vector.png';
import news1 from '../../assests/news1.png';
import news2 from '../../assests/news2.png';
import pdf1 from '../../assests/fddpdf.pdf';


// import feb1 from "../../assests/Feb1.jpg";
// import feb2 from "../../assests/Feb2.jpg";
// import feb3 from "../../assests/Feb3.jpg";
// import feb4 from "../../assests/Feb4.jpg";
// import march1 from"../../assests/March1.jpg";
// import march2 from"../../assests/March2.jpg";
// import march3 from"../../assests/March3.jpg";
// import march4 from"../../assests/March4.jpg";
// import march5 from"../../assests/March5.jpg";
// import march6 from"../../assests/March6.jpg";
// import march7 from"../../assests/March7.jpg";
// import march8 from"../../assests/March8.jpg";
// import may1 from "../../assests/may1.jpg";
// import may2 from "../../assests/may2.jpg";
// import may3 from "../../assests/may3.jpg";
// import may4 from "../../assests/may4.jpg";
// import may5 from "../../assests/may5.jpg";
// import may6 from "../../assests/may6.jpg";
// import may7 from "../../assests/may7.jpg";
// import may8 from "../../assests/may8.jpg";
// import oct1 from "../../assests/Oct1.jpg";
// import oct2 from "../../assests/Oct2.jpg";
// import april1 from "../../assests/April1.jpg";
// import april2 from "../../assests/April2.jpg";
// import april3 from "../../assests/April3.jpg";
// import april4 from "../../assests/April4.jpg";

import instagram from "../../assests/LWR insta banner 3-01.png";
import { useEffect, useState } from "react";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { Link } from "react-router-dom";

function Home() {
  useEffect(() => {
    // Set the scroll position when the component mounts
    window.scrollTo(0, 0); // Adjust the '500' value as needed
  }, []);
  const [surgeriesCounter, setSurgeriesCounter] = useState(0);
  const [campsCounter, setCampsCounter] = useState(0);
  const [countriesCounter, setCountriesCounter] = useState(0);
  const [volunteersCounter, setVolunteersCounter] = useState(0);

  useEffect(() => {
    const surgeriesInterval = setInterval(() => {
      if (surgeriesCounter < 1012) {
        setSurgeriesCounter(surgeriesCounter + 1);
      } else {
        clearInterval(surgeriesInterval);
      }
    }, -10);

    const campsInterval = setInterval(() => {
      if (campsCounter < 75) {
        setCampsCounter(campsCounter + 1);
      } else {
        clearInterval(campsInterval);
      }
    }, 10);

    const countriesInterval = setInterval(() => {
      if (countriesCounter < 13) {
        setCountriesCounter(countriesCounter + 1);
      } else {
        clearInterval(countriesInterval);
      }
    }, 10);

    const volunteersInterval = setInterval(() => {
      if (volunteersCounter < 600) {
        setVolunteersCounter(volunteersCounter + 1);
      } else {
        clearInterval(volunteersInterval);
      }
    }, 10);


    return () => {
      clearInterval(surgeriesInterval);
      clearInterval(campsInterval);
      clearInterval(countriesInterval);
      clearInterval(volunteersInterval);
    };
  }, [surgeriesCounter, campsCounter, countriesCounter, volunteersCounter]);

  const [mailData, setMaildata] = useState({
    name: "",
    email: "",
    organization: "",
  });

  const userDetails = (e) => {
    const { name, value } = e.target;
    setMaildata({ ...mailData, [name]: value });
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    const payload = {
      service_id: "service_tt2kz7w",
      template_id: "template_42v7zzh",
      user_id: "ppekGscEBiOpBosKz",
      template_params: {
        name: mailData.name,
        organization: mailData.organization,
        email: mailData.email,
      },
    };
    axios
      .post(
        "https://api.emailjs.com/api/v1.0/email/send",
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
    // .then((res) => {
    //   alert(res.data === "OK" ? "Thank you for contacting Love Without Reason. We appreciate your kindness generosity and support.  One of our team members will contact you as soon as possible." : "");
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 1000);
    // })
    // .catch((err) => {
    //   alert("Failed to Submit");
    //   console.log(err);
    // });
  };

  return (
    <>
      <Header />
      <section className=" mb-3 mt-5" style={{ backgroundColor: "#212129", minHeight: '100vh' }}>
        <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
          <ol class="carousel-indicators rounded-circle">
            <li data-bs-target="#carouselExampleSlidesOnly" data-bs-slide-to="0" class="active"></li>
            <li data-bs-target="#carouselExampleSlidesOnly" data-bs-slide-to="1"></li>
            <li data-bs-target="#carouselExampleSlidesOnly" data-bs-slide-to="2"></li>
            <li data-bs-target="#carouselExampleSlidesOnly" data-bs-slide-to="3"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="container">
                <div class="row align-items-center justify-content-between" style={{ marginTop: "10%" }}>
                  <div class="col-md-6">
                    <img src={slide1} class="img-fluid" alt="Slide1" />
                  </div>
                  <div class="col-md-6">
                    <div class="carousel-content">
                      <h2 className='text-white mt-2 sedanfont display-3 text-center'>#PhilipsDream</h2>
                      <h4 className='text-danger mt-2 sedanfont display-6 text-center' style={{ color: "#ED1C24" }}>The Legacy Continues...</h4>
                      <Link to="/philip"> <h4 className="text-center"><button className='btn btn-light mt-3 mb-3 fw-bolder ps-3 pe-3 ' style={{ borderRadius: "5px" }}>Read Philip's Dream</button></h4></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="container">
                <div class="row align-items-center justify-content-between" style={{ marginTop: "10%" }}>
                  <div class="col-md-6">
                    <div class="carousel-content">
                      <h2 className='text-white sedanfont display-5'>UNTIL THE WORLD IS <br /><span className="sedanfont display-5" style={{ color: "#ED1C24" }}>  CLEFT-FREE </span></h2>
                      {/* <button className='btn btn-light mt-3 fw-bold ps-3 pe-3' style={{ borderRadius: "5px" }}>DONATE</button> */}
                    </div>
                  </div>
                  <div class="col-md-6 text-end">
                    <img src={slide2} class="img-fluid mb-3" alt="Slide2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="container">
                <div class="row align-items-center justify-content-between" style={{ marginTop: "10%" }}>
                  <div class="col-md-6">
                    <img src={slide3} class="img-fluid" alt="Slide3" />
                  </div>
                  <div class="col-md-6 mb-3 ">
                    <div class="carousel-content">
                      <h2 className='text-white sedanfont display-5 text-start'>UNTIL THERE ARE <br /><span className="sedanfont display-5" style={{ color: "#ED1C24" }}>  NO-MORE SOLD </span></h2>
                      {/* <h4 className="text-start">   <button className='btn btn-light mt-3 mb-3 fw-bolder ps-3 pe-3 ' style={{ borderRadius: "5px" }}>DONATE</button></h4> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="container">
                <div class="row align-items-center justify-content-between" style={{ marginTop: "10%" }}>
                  <div class="col-md-6 ">
                    <div class="carousel-content">
                      <h2 className='text-white mt-5 sedanfont display-5'>BECAUSE EVERY<br /><span className="sedanfont display-5" style={{ color: "#ED1C24" }}>  CHILD MATTERS</span></h2>
                      {/* <button className='btn btn-light mt-3 fw-bolder ps-3 pe-3' style={{ borderRadius: "5px" }}>DONATE</button> */}
                    </div>
                  </div>
                  <div class="col-md-6 text-end ">
                    <img src={slide4} class="img-fluid mb-3" alt="Slide4" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section1 */}
      <section style={{ minHeight: '100vh' }} >
        <div className='container '>
          <div className="row d-flex justify-content-center align-items-center ">
            <div className="col-md-12 text-center">
              <h2 class=' text-dark fw-bold mb-0' >UPCOMING EVENTS</h2>
              <img className=" img-fluid" src={line} />
            </div>
          </div>
          <div className='row mt-3 justify-content-center align-items-center '>
            {/* <div className='col-md-4 mb-3'>
              <div className="card border-0 shadow-sm m-1">
                <img src={event1} className="card-img-top" alt="Event3" />
                <div className="card-body text-center text-white rounded-bottom" style={{ backgroundColor: "#212129" }}>
                  <h3 className="card-title fw-bold">People, Not Products</h3>
                  <h5 className="card-text text-start p-3 lh-base">People, Not Products is an awareness seminar on human trafficking, internet safety, addiction, recovery and law enforcement technologies with experts from all over the world.
                  </h5>
                  <Link to="https://allevents.in/apison/people-not-products-2024/80001528393115" href="#" className="btn text-white px-3 " target="_blank" style={{ backgroundColor: "#ED1C24" }}><h5 className="fw-bold mt-1">Register</h5></Link>
                </div>
              </div>
            </div> */}

            <div className='col-md-4 mb-2 ' >
              <div className="card border-0 shadow-sm m-1 rounded">
                <img src={event3} className="card-img-top fddhomeimg" alt="Event3" />
                <div className="card-body text-center text-white rounded-bottom" style={{ backgroundColor: "#212129" }}>
                  <h3 className="card-title fw-bold">Father Daughter Dance </h3>
                  <h5 className="card-text text-start p-3 lh-base">"Love Without Reason is proud to present the Father Daughter Dance on Friday, February 9, 2024.Spend the Friday before Valentine's day with  Father Daughter Dance!"
                  </h5>
                  <div className="d-flex justify-content-evenly flex-wrap">
                    <Link to="/FatherDaughterDanceGallery" className="btn text-white px-4 mb-2 mb-md-0" style={{ backgroundColor: "#ED1C24" }}><h5 className="fw-bold">Gallery</h5></Link>
                    {/* <button data-bs-toggle="modal" data-bs-target="#staticBackdropfdd" className="btn text-white px-4"  style={{ backgroundColor: "#ED1C24" }}><h5 className="fw-bold">Sponsor</h5></button> */}
                    <div class="modal fade" id="staticBackdropfdd" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                      <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <div className='container-fluid'>
                              <object data={pdf1} type="application/pdf" style={{ minHeight: '100vh', width: '100%' }}>
                              </object>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-4 mb-3'>
              <div className="card border-0 shadow-sm m-1">
                <img src={event2} className="card-img-top" alt="Event3" />
                <div className="card-body text-center text-white rounded-bottom" style={{ backgroundColor: "#212129" }}>
                  <h3 className="card-title fw-bold">5kRun4Love</h3>
                  <h5 className="card-text text-start p-3 lh-base">
                  Love Without Reason is hosting it's 10th annual 5K, 10K, Big Wheel, Run4Love on 14 September, 2024 at the Tennessee Riverpark at Chattanooga. Come join us for an incredible day if fun and support a great cause. Registration opens in June.
                  </h5>
                  {/* <Link to="https://5krun4love.com/about-us/" href="#" className="btn text-white px-3 " target="_blank" style={{ backgroundColor: "#ED1C24" }}><h5 className="fw-bold mt-1">Register</h5></Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='campsection'>
        {/* Section2 */}

        {/* <section
        style={{
          minHeight: "90vh",
          background:
            "linear-gradient(180deg, #099BAA 0%, rgba(255, 255, 255, 0) 77.92%, rgba(255, 255, 255, 0) 91.98%)",
        }}
      >

        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-12 text-center mt-4">
              <h2 class=" text-white fw-bold  mt-4 mb-0">MEDICAL CAMPS</h2>
              <img className="img-fluid" src={line} />
            </div>
          </div>
          <div className="row justify-content-between align-items-center">
            <div className="col-md-3">
              <button className="btn btncards" data-bs-toggle="modal" data-bs-target="#exampleModalcamp1"> <img src={camp1} className="img-fluid mt-5" /></button>
            </div>
            <div class="modal fade" id="exampleModalcamp1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title text-uppercase fw-bold" id="exampleModalLabel">cleft lip and palate medical camp</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-10">
                        <img src={camppopup1} className="img-fluid" />
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer border-0">
                    <Link to='/Upcomingcamps'><button type="button" data-bs-dismiss="modal" class="btn btn-outline-danger ">Read More</button></Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <button className="btn btncards" data-bs-toggle="modal" data-bs-target="#exampleModalcamp2"> <img src={camp2} className="img-fluid mb-5" /></button>
            </div>
            <div class="modal fade" id="exampleModalcamp2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title text-uppercase fw-bold" id="exampleModalLabel">free craniofacial medical camp</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-10">
                        <img src={camppopup2} className="img-fluid" />
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer border-0">
                    <Link to='/Upcomingcamps'><button type="button" data-bs-dismiss="modal" class="btn btn-outline-danger">Read More</button></Link>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <button className="btn btncards" data-bs-toggle="modal" data-bs-target="#exampleModalcamp3"> <img src={camp3} className="img-fluid mt-5" /></button>
            </div>
            <div class="modal fade" id="exampleModalcamp3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title text-uppercase fw-bold" id="exampleModalLabel">free craniofacial medical camp</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-10">
                        <img src={camppopup3} className="img-fluid" />
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer border-0">
                    <Link to='/Upcomingcamps'><button type="button" data-bs-dismiss="modal" class="btn btn-outline-danger">Read More</button></Link>

                  </div>
                </div>
              </div>
            </div>


            <div className="col-md-3">
              <button className="btn btncards" data-bs-toggle="modal" data-bs-target="#exampleModalcamp4"> <img src={camp4} className="img-fluid mb-5" /></button>
            </div>
            <div class="modal fade" id="exampleModalcamp4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title text-uppercase fw-bold" id="exampleModalLabel">free craniofacial medical camp</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-10">
                        <img src={camppopup4} className="img-fluid" />
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer border-0">
                    <Link to='/Upcomingcamps'><button type="button" data-bs-dismiss="modal" class="btn btn-outline-danger ">Read More</button></Link>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </section> */}
        <section className='campsection rounded'>
          <div className='container-fluid'>
            <div className='row d-flex justify-content-between align-items-center mt-3 border border-2 shadow p-4 rounded'>
              <div className='col-md-6 text-center'>
                <h2 class=" text-dark fw-bold mb-0">PREVIOUS CAMPS</h2>
                <img className="img-fluid" src={line} />
                <div className='row d-flex justify-content-center p-3'>
                  <div className='col-md-6'>
                    <button type="button" className="btn border-0 btncards" data-bs-toggle="modal" data-bs-target="#exampleModalcamp1">
                      <img className='img-fluid rounded' src={camp1} />
                    </button>
                    <div class="modal fade" id="exampleModalcamp1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-lg" >
                        <div class="modal-content" >
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">CLEFT LIP AND PALATE MEDICAL CAMP</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <div class="row d-flex justify-content-center">
                              <div classname="col-md-10">
                                <img className='img-fluid rounded' src={camp1} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <button type="button" className='mt-5 btn btncards border-0' data-bs-toggle="modal" data-bs-target="#exampleModalcamp2">
                      <img className='img-fluid rounded' src={camp3} />
                    </button>
                    <div class="modal fade" id="exampleModalcamp2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-lg" >
                        <div class="modal-content" >
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel" >FREE CLEFT LIP AND PALATE MEDICAL CAMP</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <div class="row d-flex justify-content-center">
                              <div classname="col-md-10">
                                <img className='img-fluid rounded' alt="camp3" src={camp3} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6 text-center'>
                <h2 class=" text-dark fw-bold mb-0">UPCOMING CAMPS</h2>
                <img className="img-fluid" src={line} />
                <div className='row d-flex justify-content-center p-3'>
                  <div className='col-md-6'>
                    <button type="button" className=' btn border-0 btncards' data-bs-toggle="modal" data-bs-target="#exampleModalcamp3">
                      <img className='img-fluid rounded' src={camp2} />
                    </button>
                    <div class="modal fade" id="exampleModalcamp3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-lg " >
                        <div class="modal-content" >
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">FREE CRANIOFACIAL MEDICAL CAMP</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <div class="row d-flex justify-content-center">
                              <div classname="col-md-10">
                                <img className='img-fluid rounded' src={camp2} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <button type="button" className='mt-5 btn border-0 btncards' data-bs-toggle="modal" data-bs-target="#exampleModalcamp4">
                      <img className='img-fluid rounded' src={camp4} />
                    </button>
                    <div class="modal fade" id="exampleModalcamp4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-lg " >
                        <div class="modal-content" >
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">CLEFT LIP AND PALATE MEDICAL CAMP</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <div class="row d-flex justify-content-center">
                              <div classname="col-md-10">
                                <img className='img-fluid rounded' src={camp4} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className="mb-5" style={{ minHeight: "100vh" }}>
          <div className="container-fluid p-5">
            <div className="row d-flex justify-content-center">
              <div className="col-md-12 text-center">
                <h2 class=" text-dark fw-bold mb-0">WHAT WE DO</h2>
                <img className="img-fluid" src={line} />
              </div>
            </div>

            <div className="row d-flex justify-content-center align-items-center mt-3">
              <div className="col-md-4">
                <div className="card border-0 rounded">
                  <Link to="/Craniofacial">
                    {" "}
                    <img src={wwd1} className="card-img-top" alt="Image 1" />
                  </Link>
                  <div className="card-body bg-light text-center rounded border-0">
                    <div className="row">
                      <div className="col-9">
                        <Link className="text-decoration-none" to="/Craniofacial">
                          {" "}
                          <h5 className="fw-bold p-0 text-dark card-text ">
                            {" "}
                            CRANIOFACIAL SURGERY{" "}
                          </h5>
                        </Link>
                      </div>
                      <div className="col-3">
                        <Link to="/Craniofacial">
                          <img className="img-fluid" src={share} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 rounded">
                  <Link to="/InnovativeSolutions">
                    {" "}
                    <img
                      src={wwd2}
                      className="img-fluid card-img-top mb-0"
                      alt="Image 1"
                    />
                  </Link>
                  <div className="card-body bg-light text-center rounded border-0">
                    <div className="row">
                      <div className="col-9">
                        <Link className="text-decoration-none" to="/InnovativeSolutions">
                          {" "}
                          <h5 className="fw-bold text-dark p-0 card-text">
                            {" "}
                            INNOVATIVE SOLUTIONS
                          </h5>
                        </Link>
                      </div>
                      <div className="col-3">
                        <Link to="/InnovativeSolutions">
                          <img className="img-fluid" src={share} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card border-0 mt-3">
                  <Link to="/InnovativeSolutions">
                    {" "}
                    <img
                      src={wwd3}
                      className="img-fluid card-img-top"
                      alt="Image 1"
                    />
                  </Link>
                  <div className="card-body bg-light text-center rounded border-0">
                    <div className="row">
                      <div className="col-9">
                        <Link className="text-decoration-none" to="/InnovativeSolutions">
                          {" "}
                          <h5 className="fw-bold text-dark p-0 card-text">
                            {" "}
                            SET FREE PADS
                          </h5>
                        </Link>
                      </div>
                      <div className="col-3">
                        <Link to="/InnovativeSolutions">
                          <img className="img-fluid" src={share} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0">
                  <Link to="/AntiHumanTrafficking">
                    {" "}
                    <img
                      src={wwd4}
                      className="img-fluid card-img-top"
                      alt="Image 1"
                    />
                  </Link>
                  <div className="card-body bg-light text-center rounded border-0">
                    <div className="row">
                      <div className="col-9">
                        <Link className="text-decoration-none" to="/AntiHumanTrafficking">
                          {" "}
                          <h5 className="fw-bold p-0 card-text text-dark">
                            {" "}
                            ANTI HUMAN TRAFFICKING
                          </h5>
                        </Link>
                      </div>
                      <div className="col-3">
                        <Link to="/Human">
                          <img className="img-fluid" src={share} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="global-banner" style={{ minHeight: "100vh" }}>
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-md-12 text-center  mt-5">
                <h2 class=" text-white fw-bold mb-0">GLOBAL IMPACT</h2>
                <img className=" img-fluid" src={line} />
              </div>
            </div>
            <div className="row d-flex justify-content-between align-items-center">
              <div className="col-md-4  text-white mt-5 text-start">
                <div className="text-start mt-4">
                  <h1 className="fw-bold"><br></br></h1>
                  <h5 className="fw-bold text-uppercase"><br></br></h5>
                </div>
                <div className="text-start mt-4 ">
                  <h1 className="fw-bold">300+</h1>
                  <h5 className="fw-bold  text-uppercase">Women Rescued</h5>
                </div>
                <div className="text-start mt-4">
                  <h1 className="fw-bold">1000+</h1>
                  <h5 className="fw-bold text-uppercase">Set Free Pads</h5>
                </div>
                <div className="text-start mt-4">
                  <h1 className="fw-bold">20,000</h1>
                  <h5 className="fw-bold text-uppercase">Educated Globally</h5>
                </div>
              </div>
              <div className="col-md-3 text-end text-white mt-5 pe-4">
                <div className="text-center">
                  <h1 className="fw-bold text-end">{surgeriesCounter}</h1>
                  <h5 className="fw-bold text-end">SURGERIES</h5>
                </div>
                <div className="text-center mt-4">
                  <h1 className="fw-bold text-end">{campsCounter}</h1>
                  <h5 className="fw-bold text-end">CAMPS</h5>
                </div>
                <div className="text-center mt-4">
                  <h1 className="fw-bold text-end">{countriesCounter}</h1>
                  <h5 className="fw-bold text-end">COUNTRIES</h5>
                </div>
                {/* <div className="text-center mt-4">
                <h1 className="fw-bold text-end">{volunteersCounter}+</h1>
                <h5 className="fw-bold text-end">VOLUNTEERS</h5>
              </div> */}

                <div className="text-center mt-4 mb-5">
                  <h1 className="fw-bold text-end">05</h1>
                  <h5 className="fw-bold text-end text-uppercase">
                    Water Wells
                  </h5>
                </div>
                {/* <div className="text-start mt-4 mb-5">
                <h1 className="fw-bold text-end">300+</h1>
                <h5 className="fw-bold text-end text-uppercase">Women Rescued</h5>
              </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* section3 */}
        {/* <section style={{ minHeight: "100vh" }}>
        <div className="container-fluid">

          <div className="row d-flex justify-content-center">
            <div className="col-md-5 text-center mt-5 ">
              <h2 className='text-dark fw-bold mb-0'>SUSAN'S BLOGS</h2>
              <img className="img-fluid" src={line} />
              <div class="card border-0 shadow-sm mt-3">
                <img class="card-image border-0" src={susan} alt="Susan's Blog" />
                <button class="btn border text-danger fw-bold">Read Blogs</button>
              </div>

            </div>
            <div className="col-md-5 text-center mt-5">
              <h2 className="text-dark fw-bold mb-0">NEWSLETTER</h2>
              <img className="img-fluid" src={line} alt="Divider Line" />
              <img className="img-fluid border-0 mt-3" src={news} alt="Susan's Blog" />
              <button class="btn border text-danger font-weight-bold mt-1">Read News</button>
            </div>
          </div> 
        </div>
      </section> */}

        <section
          style={{
            minHeight: "70vh",
            background:
              "linear-gradient(180deg, rgba(9, 155, 170, 0) 0%, #099BAA 100%)",
          }}
        >
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-md-6">
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 text-center">
                    <h2 class=" text-dark fw-bold mt-3 mb-0">STAY CONNECTED</h2>
                    <img className=" img-fluid" src={line} />
                  </div>
                </div>
                <div className="row d-flex justify-content-center">
                  <div className="col-md-3 mt-2 p-2">
                    <img className="img-fluid" src={logo} />
                  </div>
                </div>
                <div className="row justify-content-center align-items-center">
                  <div className="col-md-10 text-center">
                    <form onSubmit={sendEmail}>
                      <input
                        type="text"
                        placeholder="Name"
                        name="name"
                        className="form-control rounded p-2 mt-4"
                        onChange={(e) => {
                          userDetails(e);
                        }}
                      />
                      <input
                        type="text"
                        placeholder="Organization"
                        name="organization"
                        className="form-control rounded p-2 mt-4"
                        onChange={(e) => {
                          userDetails(e);
                        }}
                      />
                      <input
                        type="email"
                        placeholder="Email"
                        name="email"
                        className="form-control rounde p-2 mt-4"
                        onChange={(e) => {
                          userDetails(e);
                        }}
                      />
                      <button
                        className="btn btn-danger mt-4 fw-bold px-4 shadow-sm"
                        type="submit"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal" data-bs-target="#exampleModalhome"
                      >
                        Subscribe
                      </button>
                      <div class="modal fade" id="exampleModalhome" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            {/* <div class="modal-header">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div> */}
                            <div class="modal-body">
                              <h5 class="modal-title fw-bolder text-danger" id="exampleModalLabel">LOVE WITHOUT REASON</h5>
                              <hr />

                              <div className="row d-flex justify-content-center">
                                <div className="col-md-12 fs-5">
                                  Thank you for contacting Love Without Reason. We appreciate your kindness, generosity and support.  One of our team members will contact you as soon as possible.
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer border-0">
                              <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-5 text-center mt-5">
              <div className="row d-flex justify-content-center">
                <div className="col-md-7 text-center  mt-5">
                  <h2 class=' text-dark fw-bold'>INSTAGRAM FEEDS</h2>
                  <img className=" img-fluid" src={line} />
                </div>
              </div>
              <div className="card rounded  border-0 mt-2 p-1 ">
                <img className="img-fluid shadow rounded " src={instagram} />
              </div>
              <button className='btn btn-danger mt-2 mb-3 px-4 fw-bold  ' style={{ borderRadius: "5px" }}>View Profile</button>
            </div> */}

              <div className="col-md-5 text-center mt-5">
                <h2 className="text-dark fw-bold mb-0">NEWS LETTERS</h2>
                <img className="img-fluid" src={line} alt="Divider Line" />
                <Link to='/NewsLetters'><img
                  className="img-fluid border-0 mt-3"
                  src={news}
                  alt="News-Letters"
                /></Link>
                <Link to='/NewsLetters' class="btn btn-danger mt-4 fw-bold shadow-sm mb-4">Read News</Link>
              </div>
            </div>
          </div>
        </section>
      </section>
      <Footer />
    </>
  );
}
export { Home };
